import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRateGridPriceSource.ts
var t = () => e("rateGridPriceSource");
//#endregion
export { t as useTrRateGridPriceSource };
